import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import DataTable from "../components/table/dataTable"
import {hasRoles, getTokenExpired } from "../components/utils"
import PageLayout from "../components/layouts/pageLayout"

const MyStudentsPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    if (getTokenExpired()) return navigate("/login")

    const checkTutorRole = async () => {
      try {
        if (!hasRoles("Tutor")) {
          navigate("/no-access")
        }
      } catch (error) {
        console.error("Error checking roles:", error)
        navigate("/no-access")
      }
    }

    checkTutorRole()
  }, [navigate])

  return (
    <PageLayout title="My Students">
      <DataTable tableId={3}/>
    </PageLayout>
  )
}

export default MyStudentsPage
